import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {Pencil, Trash2, MoreHorizontal, Eye, FilePlus} from 'lucide-vue-next'
  import {
    DropdownMenu,
    DropdownMenuContent, DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuTrigger
  } from '@/components/ui/dropdown-menu'
  import { Button } from '@/components/ui/button'
  import {ref} from "vue";
  import DeleteDialog from "@/components/tables/DeleteDialog.vue";
  import router from "@/router";
  import UploadDocumentDialog from "@/components/building/UploadDocumentDialog.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingsDataTableDropDown',
  props: {
    object: {},
    entity: {}
  },
  setup(__props: any) {

  const props = __props

  const isDeleteDialogOpen = ref(false);
  const isDocumentDialogOpen = ref(false);

  const setIsDocumentDialogOpen = (value: boolean) => {
    isDocumentDialogOpen.value = value;
  };

  const setIsDeleteDialogOpen = (value: boolean) => {
    isDeleteDialogOpen.value = value;
  };

  const editBuilding = async () => {
    await router.push({name: 'newBuilding', params: {id: props.object.id}});
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenu), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DropdownMenuTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createVNode(_unref(Button), {
            variant: "ghost",
            class: "w-8 h-8 p-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(MoreHorizontal), { class: "w-4 h-4" })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DropdownMenuContent), { align: "end" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DropdownMenuLabel), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.actions')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(DropdownMenuItem), {
            onClick: _withModifiers(editBuilding, ["prevent"]),
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Pencil), { class: "mr-2 h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('table.edit')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(DropdownMenuItem), {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'viewBuilding', params: { id: props.object.id }})), ["prevent"])),
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Eye), { class: "mr-2 h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('table.view')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(DropdownMenuItem), {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (setIsDocumentDialogOpen(true)), ["prevent"])),
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FilePlus), { class: "mr-2 h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('building.add_document')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(DropdownMenuItem), {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (setIsDeleteDialogOpen(true)), ["prevent"])),
            class: "cursor-pointer"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Trash2), { class: "mr-2 h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('table.delete')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(DeleteDialog, {
        entity: props.entity,
        object: props.object,
        open: isDeleteDialogOpen.value,
        "set-open": setIsDeleteDialogOpen
      }, null, 8, ["entity", "object", "open"]),
      _createVNode(UploadDocumentDialog, {
        entity: props.entity,
        "entity-id": props.object.id,
        open: isDocumentDialogOpen.value,
        "set-open": setIsDocumentDialogOpen,
        onEdit: _cache[3] || (_cache[3] = ($event: any) => (setIsDocumentDialogOpen(false)))
      }, null, 8, ["entity", "entity-id", "open"])
    ]),
    _: 1
  }))
}
}

})